/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-pencil': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M12.3 3.7l4 4L4 20H0v-4L12.3 3.7zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z"/>'
  }
})
